import priceLabelAccent from '../../../common/algorithms/price-label-accent';

const secondary = ({ secondaryColor, backgroundColor, secondaryColorPalette, whiteColor }) =>
  priceLabelAccent({
    targetColor: secondaryColor,
    backgroundColor,
    targetColorPalette: secondaryColorPalette,
    whiteColor,
    reduceCondition: (ratio) => ratio >= 1.5,
    increaseCondition: (ratio) => ratio >= 1.1,
  });

export default secondary;
